import { Search } from 'lucide-react';
// TEMP: Bulk Update hidden — uncomment to restore
// import { SquarePen } from 'lucide-react';
import { Input } from '@/components/ui/input';
import { InvoiceFilterPopover, type InvoiceFilters } from './InvoiceFilterPopover';

interface Props {
  searchValue: string;
  onSearchChange: (v: string) => void;
  filters: InvoiceFilters;
  onFiltersChange: (f: InvoiceFilters) => void;
  // TEMP: Bulk Update hidden — uncomment to restore
  // selectedCount: number;
  // onBulkUpdate: () => void;
}

export function InvoiceToolbar({
  searchValue,
  onSearchChange,
  filters,
  onFiltersChange,
}: Props) {
  return (
    <div className="flex flex-wrap items-center justify-between gap-3">
      <div className="relative w-full max-w-80">
        <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-silver" />
        <Input
          value={searchValue}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder="Search"
          className="h-10 rounded-full border border-smoke pl-9 focus:border-primary-s500"
        />
      </div>
      <div className="flex items-center gap-3">
        {/* TEMP: Bulk Update hidden — uncomment to restore
        <button
          type="button"
          onClick={onBulkUpdate}
          disabled={selectedCount === 0}
          className="flex h-9 items-center gap-2 rounded-full border border-primary-s500 px-4 text-sm font-medium text-primary-s500 hover:bg-primary-s50 disabled:cursor-not-allowed disabled:border-smoke disabled:text-silver disabled:hover:bg-transparent"
        >
          <SquarePen size={15} />
          Bulk Update{selectedCount > 0 ? ` (${selectedCount})` : ''}
        </button>
        */}
        <InvoiceFilterPopover filters={filters} onChange={onFiltersChange} />
      </div>
    </div>
  );
}
